import React, { Component } from 'react';
import { getUrlParams } from '../../utils/';
import SearchMain from '../components/search/search-main.jsx';



export default class Search extends Component {
    constructor(props) {
        super(props);

        this.state = {
            
        };

    }



    render() {
        return (
            <div className="container">
                <SearchMain />
            </div>
        );
    }
}
